export default __webpack_public_path__ + "static/media/img_6.0ee5dea8.jpg";